<template>
  <div class="advertising-page">
    <header class="hero-section fade-in-section">
      <div class="hero-text">
        <h1>Advertising Services</h1>
        <p class="hero-desc-main">
          Our advertising solutions are crafted to drive growth and deliver measurable results. Whether you’re looking to expand your brand presence or launch a new campaign, our creative team is here to bring your ideas to life with innovative strategies and dynamic approaches.
        </p>
      </div>
    </header>

    <section class="service-overview fade-in-section">
      <div class="service-info">
        <h2>Our Expertise</h2>
        <p>
          We specialize in digital marketing, social media strategies, print advertising, and much more. From concept to execution, we ensure your brand message reaches the right audience in the most effective way possible.
        </p>
      </div>
      <div class="service-img">
        <img src="https://media.istockphoto.com/id/842214470/photo/young-designers-discussing-the-color-palette.jpg?s=612x612&w=0&k=20&c=nAJgTF73SOAoiDLY-T1KOJGF8azZIX9C52X5xGy69K4=" loading="eager" alt="Advertising Strategy" class="advertising-img">
      </div>
    </section>

    <div class="stats-section fade-in-section">
      <div class="stats-item">
        <div class="stats-heading">{{ animatedNumbers.projects }}+</div>
        <div class="stats-sub-heading">Campaigns Executed</div>
      </div>
      <div class="stats-item">
        <div class="stats-heading">{{ animatedNumbers.years }} Years</div>
        <div class="stats-sub-heading">In the Advertising Industry</div>
      </div>
      <div class="stats-item">
        <div class="stats-heading">{{ animatedNumbers.clients }}+</div>
        <div class="stats-sub-heading">Happy Clients</div>
      </div>
    </div>

    <section class="services-section fade-in-section">
      <h2>Our Advertising Services</h2>
      <div class="service-cards">
        <div class="service-card">
          <h3>Social Media Advertising</h3>
          <p>Engage with your audience on platforms like Facebook, Instagram, and LinkedIn through targeted campaigns that deliver results.</p>
        </div>
        <div class="service-card">
          <h3>Print Advertising</h3>
          <p>Design eye-catching print ads for magazines, newspapers, and billboards to ensure maximum visibility for your brand.</p>
        </div>
        <div class="service-card">
          <h3>Search Engine Marketing</h3>
          <p>Increase your online presence with search engine advertising strategies, driving qualified traffic to your website.</p>
        </div>
      </div>
    </section>

    <footer class="footer">
      <p>&copy; 2025 Your Company. All Rights Reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Advertising',
  data() {
    return {
      animatedNumbers: {
        projects: 0,
        years: 0,
        clients: 0,
      }
    };
  },
  mounted() {
    this.animateNumber('projects', 200, 2000);
    this.animateNumber('years', 10, 2500);
    this.animateNumber('clients', 150, 3000);
    this.observeSections();
  },
  methods: {
    animateNumber(ref, target, duration) {
      let start = this.animatedNumbers[ref];
      let stepTime = 16;
      let step = (target - start) / (duration / stepTime);

      const updateNumber = () => {
        if (start < target) {
          start += step;
          this.animatedNumbers[ref] = Math.floor(start);
          requestAnimationFrame(updateNumber);
        } else {
          this.animatedNumbers[ref] = target;
        }
      };

      requestAnimationFrame(updateNumber);
    },
    observeSections() {
      const sections = document.querySelectorAll('.fade-in-section');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      sections.forEach(section => observer.observe(section));
    }
  }
};
</script>

<style scoped>
/* Initial state for fade-in animation */
.fade-in-section {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease-out, transform 1s ease-out;
}

/* When element becomes active (in view) */
.fade-in-section.active {
  opacity: 1;
  transform: translateY(0);
}

/* Hero Section */
.hero-section {
  background-color: #438d47; /* Green background */
  padding: 60px 20px;
  text-align: center;
}

.hero-text h1 {
  font-size: 2.5rem;
  color: #FFF;
  margin-bottom: 20px;
}

.hero-desc-main {
  font-size: 1.2rem;
  color: #DDD;
  margin-bottom: 30px;
}

/* Advertising Image */
.advertising-img {
  width: 100%;
  max-height: 500px;
  object-fit: cover;
  border-radius: 10px;
}

/* Stats Section */
.stats-section {
  display: flex;
  justify-content: space-around;
  background-color: #2b2c38;
  padding: 40px 20px;
  color: white;
  text-align: center;
}

.stats-item {
  flex: 1;
  margin: 0 20px;
}

.stats-heading {
  font-size: 2rem;
  font-weight: bold;
}

.stats-sub-heading {
  font-size: 1rem;
  color: #d0d4c3;
}

/* Services Section */
.services-section {
  background-color: #f9f9f9;
  padding: 40px 20px;
  text-align: center;
}

.services-section h2 {
  color: #D2B58C; /* Wheat color */
  font-size: 2rem;
  margin-bottom: 20px;
}

.service-cards {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.service-card {
  background: #FFF;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
}

.service-card h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 10px;
}

.service-card p {
  color: #777;
  font-size: 1rem;
}

/* Footer */
.footer {
  text-align: center;
  padding: 20px;
  background-color: #283E4A;
  color: white;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.service-info{
  padding: 8%;
    color: wheat;
}
</style>
